import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { alpha } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";

export default function TermsPage() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <MKBox
        minHeight="100vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.8),
              rgba(gradients.dark.state, 0.8)
            )}, url("https://images.unsplash.com/photo-1557683316-973673baf926?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1929&q=80")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          display: "grid",
          placeItems: "center",
          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 4 },
        }}
      >
        <Container maxWidth="xl">
          <Grid container justifyContent="center" spacing={4}>
            <Grid item xs={12} md={10}>
              <Card
                sx={{
                  borderRadius: 4,
                  boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.2)}`,
                  backdropFilter: "blur(8px)",
                  backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.9),
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <CardContent sx={{ p: { xs: 3, md: 6 } }}>
                  <Box sx={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    gap: 3,
                    mb: 6,
                    flexWrap: "wrap"
                  }}>
                    <Button
                      component={Link}
                      to="/rifas"
                      variant="contained"
                      color="success"
                      size="large"
                      startIcon={<ConfirmationNumberIcon />}
                      sx={{
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        boxShadow: 3,
                        background: "linear-gradient(45deg, #4CAF50 30%, #81C784 90%)",
                        color: "#fff",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: 6,
                          background: "linear-gradient(45deg, #388E3C 30%, #66BB6A 90%)",
                          color: "white",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      Ver Rifas
                    </Button>
                  </Box>

                  <MKTypography
                    variant="h3"
                    color="primary"
                    fontWeight="bold"
                    textAlign="center"
                    mb={4}
                    sx={{
                      textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
                      fontSize: { xs: "2rem", md: "2.5rem" },
                    }}
                  >
                    TÉRMINOS Y CONDICIONES
                  </MKTypography>
                  <MKTypography
                    variant="h4"
                    color="primary"
                    fontWeight="bold"
                    textAlign="center"
                    mb={6}
                    sx={{
                      textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
                      fontSize: { xs: "1.5rem", md: "2rem" },
                    }}
                  >
                    GANA CON BENDICIÓN EN MANOS
                  </MKTypography>

                  <Grid container spacing={4}>
                    {/* Columna Izquierda */}
                    <Grid item xs={12} md={6}>
                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          1. Reclamos y Plazos
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Para reclamos de pagos y devoluciones:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Plazo de 24 horas para comunicarse con soporte técnico"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Debe incluir número de referencia y comprobante de pago"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Las devoluciones solo aplican si los tickets no han sido validados"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Los reclamos deben realizarse a través de la plataforma o correo oficial"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>

                      <Divider sx={{ my: 4 }} />

                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          2. Compra y Tickets
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Requisitos de compra:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Compra mínima de 2 tickets"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Pago debe realizarse en la moneda especificada"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Debe proporcionar datos de contacto válidos"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>

                      <Divider sx={{ my: 4 }} />

                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          3. Requisitos de Participación
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Edad y ubicación:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Mayores de 18 años"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Participación válida en territorio venezolano"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Identificación vigente requerida"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>
                    </Grid>

                    {/* Columna Derecha */}
                    <Grid item xs={12} md={6}>
                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          4. Entrega de Premios
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Proceso de entrega:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Plazo máximo de 15 días hábiles"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Incluye factura y garantía oficial"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Entrega personal o por servicio de mensajería"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Costos de envío a cargo del ganador si aplica"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>

                      <Divider sx={{ my: 4 }} />

                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          5. Propiedad Intelectual
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Uso de marca:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Prohibido uso sin autorización escrita"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Incluye nombre, logos y materiales"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Se tomarán acciones legales por uso no autorizado"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Derechos reservados en su totalidad"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>

                      <Divider sx={{ my: 4 }} />

                      <MKBox sx={{ mb: 4 }}>
                        <MKTypography
                          variant="h5"
                          color="primary"
                          fontWeight="bold"
                          mb={3}
                          sx={{
                            borderBottom: "2px solid",
                            borderColor: "primary.main",
                            pb: 1,
                            display: "inline-block",
                          }}
                        >
                          6. Protección de Datos
                        </MKTypography>
                        <MKTypography
                          variant="body1"
                          paragraph
                          sx={{
                            color: "text.secondary",
                            fontWeight: 500,
                            mt: 2,
                          }}
                        >
                          • Uso de información:
                        </MKTypography>
                        <List dense sx={{ pl: 2 }}>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Solo para gestión de compras y premios"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Almacenamiento en servidores seguros"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="No se comparte con terceros"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                          <ListItem sx={{ py: 0.5 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 8, color: "primary.main" }} />
                            </ListItemIcon>
                            <ListItemText
                              primary="Derecho a solicitar eliminación de datos"
                              primaryTypographyProps={{
                                sx: { color: "text.primary", fontWeight: 400 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </MKBox>
                    </Grid>
                  </Grid>

                  {/* Sección de Contacto - Ancho completo */}
                  <Grid item xs={12}>
                    <Divider sx={{ my: 4 }} />
                    <MKBox sx={{ textAlign: "center", mt: 4 }}>
                      <MKTypography
                        variant="h5"
                        color="primary"
                        fontWeight="bold"
                        mb={3}
                      >
                        Contacto
                      </MKTypography>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6} md={4}>
                          <MKTypography variant="body1" color="text.secondary">
                            Correo: ganaconbendicionenmanos@gmail.com
                          </MKTypography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MKTypography variant="body1" color="text.secondary">
                            WhatsApp: +584263911161
                          </MKTypography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MKTypography variant="body1" color="text.secondary">
                            Horario: Lunes a Viernes, 9:00 AM - 5:00 PM
                          </MKTypography>
                        </Grid>
                      </Grid>
                    </MKBox>
                  </Grid>

                  <MKBox sx={{ mt: 6, textAlign: "center" }}>
                    <MKTypography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontStyle: "italic",
                        opacity: 0.8,
                      }}
                    >
                      Última actualización: 20 de mayo de 2025
                    </MKTypography>
                  </MKBox>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
} 